import { render } from "./tpl_integral.vue?vue&type=template&id=f8ba6706&scoped=true"
import script from "./tpl_integral.vue?vue&type=script&lang=js"
export * from "./tpl_integral.vue?vue&type=script&lang=js"

import "./tpl_integral.vue?vue&type=style&index=0&id=f8ba6706&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ba6706"],['__file',"src/views/wap/template/tpl_integral.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8ba6706"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8ba6706', __exports__)) {
    console.log('reload')
    api.reload('f8ba6706', __exports__)
  }
  
  module.hot.accept("./tpl_integral.vue?vue&type=template&id=f8ba6706&scoped=true", () => {
    console.log('re-render')
    api.rerender('f8ba6706', render)
  })

}


export default __exports__